module.exports = __webpack_public_path__ + "img/7.ef9e5756.png";